import { remove } from "lodash";

export class SamplesLookup {

    static GetSampleColumn(id: number): string {
        switch (id) {
            case 1: return "Blood";
            case 2: return "PBMC";
            case 3: return "Stool";
            case 4: return "Nasal";
            case 5: return "Skin Biopsy";
            default: return "Unknown";
        }
    }

    static GetSampleOrdering(id: number): number {
        switch (id) {
            case 1: return 1; // Blood
            case 4: return 2; // Nasal
            case 2: return 3; // PBMC
            case 5: return 4; // Skin Biopsy
            case 3: return 5;  // Stool
            default: return 100; // Unknown
        } 
    }

    static GetDescriptionColumn(id: number): string {
        switch (id) {
            case 1: return "Blood samples collected";
            case 2: return "Nasal swab";
            case 3: return "PBMC samples collected";
            case 4: return "Skin biopsy performed";
            case 5: return "Stool kit distributed";
            default: return "Unknown";
        }
    }

    static GetVisitFullNameColumn(id: number): string {
        switch (id) {
            case 1: return "Baseline";
            case 2: return "Day 120";
            case 3: return "Day 45";
            case 4: return "Day 60";
            case 5: return "Day 90";
            case 6: return "Mid-Intervention";
            case 7: return "End of Dosing Clinic Visit / Day EOD";
            case 8: return "End of Intervention (3 month)"; 
            case 9: return "End of Intervention (9 month)"; 
            case 10: return "Follow-up";
            case 11: return "End of Intervention";
            case 12: return "End of Study";
            default:
                console.warn("Unknown VisitFullNId Encountered: ", id);
                return "Unknown";
        }
    }

    static GetVisitFullNameOrdering(id: number): number {
        switch (id) {
            case 1: return 1; // Baseline
            case 6: return 2; // Middle-Intervention
            case 8: return 3; // End of Intervention (3 month)
            case 9: return 4; // End of Intervention (9 month)
            case 11: return 5; // End of Intervention
            case 3: return 6; // Day 45
            case 4: return 7; // Day 60
            case 5: return 8; // Day 90
            case 2: return 9; // Day 120
            case 7: return 10; // End of Dosing Clinic Visit / Day EOD
            case 12: return 11; // End of Study
            case 10: return 12; // Follow-up
            default: return 100; // Unknown
        }
    }

    static GetSamplesSatusColumn(id: number): string {
        switch (id) {
            case 1: return "Completed";
            case 2: return "Discontinued Prior";
            case 3: return "Missing";
            case 4: return "Not Done";
            case 5: return "Not Yet Due";
            case 6: return "Overdue";
            default: return "Unknown";
        }
    }

    static GetSamplesColorIndex(id: number): number {
        switch (id) {
            case (1): return 500; // Completed
            case (2): return 504; // Discontinued Prior
            case (3): return 502; // Missing
            case (4): return 503; // Not Done
            case (5): return 501; // Not Yet Due
            case (6): return 502; // Overdue
            default: return 0;
        }
    }

    static GetSamplesStatusGroups(): { label: string, ids: number[] }[] {
        return [
            { label: "Completed", ids: [1] },
            { label: "Overdue / Missing", ids: [6, 3] },
            { label: "Not Done", ids: [4] },
            { label: "Discontinued Prior", ids: [2] },
            { label: "Not Yet due", ids: [5] },
        ]
    }

    static GetReasonNotDoneColumn(id: number): string {
        switch (id) {
            case 1: return "Not collected by Site";
            case 2: return "Other";
            case 3: return "Participant refused to provide samples";
            case 4: return "Patient refused to provide samples";
            case 5: return "Stick difficulties / Unable to find vein";
            case 6: return "Visit not done";
            case 100: return "Unknown"; //reasons
            case 101: return "Couldn't provide sample during EOI visit.";
            case 102: return "Day 45 visit not conducted. Page unnecessary.";
            case 103: return "Day 60 visit not done, pt sick/fever";
            case 104: return "Early termination";
            case 105: return "Error- entered into PBMC form on Unscheduled Visit";
            case 106: return "Error PBMC form filled out under Unscheduled Visit";
            case 107: return "Error- Samples entered on PBMC Unscheduled Visit";
            case 108: return "Error. Entered in PBMC form in unscheduled visits.";
            case 109: return "Error. PBMC Kit.";
            case 110: return "Form populated by error.";
            case 111: return "Mailed to subjects home address";
            case 112: return "Participant screen failed";
            case 113: return "participant did not provide baseline stool sample";
            case 114: return "Patient was unable to have bowel movement";
            case 115: return "PARTICIPANT WAS A SCREEN FAIL";
            case 116: return "PARTICIPANT WAS SCREEN FAIL";
            case 117: return "PBMC form used";
            case 118: return "patient didn't show up for her DAY 45 visit";
            case 119: return "ppt missed visit";
            case 120: return "PT No Show for Appointment.";
            case 121: return "subject misrandomize to result early termination";
            case 122: return "Subject did not show up to appointment";
            case 123: return "Subject ineligible, samples destroyed on site";
            case 124: return "Subject was an early termination.";
            case 125: return "Subject withdrawn from study";
            case 126: return "Too many tubes collected during Obs. visit.";
            case 127: return "Visit did not occur";
            case 128: return "Visit not done, participant unable to come in.";
            case 129: return "Visit not completed";
            case 130: return "visit not completed";
            default: return "Unknown";
        }
    }
}